module.exports = __webpack_public_path__ + "static/media/feedback.0bae02a1.svg";